<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showError" @change="showErrorChange" active-text="显示异常票" inactive-text=""></el-switch>
			</el-header>
			<el-main class="main flex">
				<el-row :gutter="20" style="margin: 10px 0px;" v-loading = "staticloading">
					<el-col :span="6">
						<div>
							<el-statistic group-separator="" :precision="0" :value="statics.nazhinum"
								title="云系统数量"></el-statistic>
						</div>
					</el-col>
					<el-col :span="6">
						<div>
							<el-statistic group-separator="" :precision="0" :value="statics.yqdznum"
								title="亿企赢数量"></el-statistic>
						</div>
					</el-col>
				</el-row>				
				<vxe-grid v-if="list_gridOptions" ref="outputinvoicereport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>		
			</el-main>
		</el-container>
		<invoiceConfig ref="invoiceConfig" :invoicedata="invoicedata" :tab="tab" />
		<createyqdzorder ref="outputinvoiceCreateyqdzorder" />
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import invoiceConfig from './lib/invoice/index.vue'
	import createyqdzorder from './lib/createyqdzorder/index.vue'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				invoicedata:[],
				tab:[],
				invoicecompany:[],
				param:null,
				currentrow:null,
				loading:false,
				showError:false,
				transTime: null,
				reportName: 'outputinvoice',
				foreingKey:{},
				staticloading:false,
				statics:{
					nazhinum:0,
					yqdznum:0
				},
				list_formConfig: [{
					field: 'customerId',
					title: '我方公司',
					span: 4,
					//resetValue:'1906330795208',
					itemRender: {
						name: '$select',
						//defaultValue:'1906330795208',
						props:{
							emptyoption:false,
							selectoptions:[]
						}
					}
				},{
					field: 'invoiceNumber',
					title: '发票编码',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					},
					
				},{
					field: 'relationres',
					title: '关联商品',
					span: 4,
					itemRender: {
						name: '$select',
						props:{
							multiple:true,
							emptyoption:false,
							selectoptions:[{
								label:'未关联',
								value:0
							},{
								label:'部分关联',
								value:2
							},{
								label:'已关联',
								value:1
							}]
						}
					}
				},{
					field: 'isrelation',
					title: '匹配任务',
					span: 4,
					itemRender: {
						name: '$select',
						props:{
							multiple:false,
							emptyoption:false,
							selectoptions:[{
								label:'未执行',
								value:'0'
							},{
								label:'已执行',
								value:'1'
							}]
						}
					}
				},{
					field: 'taxItem',
					title: '征税项目',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'relationsource',
					title: '关联来源',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'headorderId',
					title: '线上订单号',
					span: 4,
					itemRender: {
						name: '$input'
					}
				},{
					field: 'bizDate',
					title: '开票日期',
					span: 4,
					itemRender: {
						name: '$datePicker',
						props:{}
					}
				},{
					field: 'ignore',
					title: '忽略',
					span: 4,
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[{
								label:'否',
								value:'0'
							},{
								label:'是',
								value:'1'
							}]
						}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.invoice.listoutputinvoice({
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
						...{
							fundtype:this.fundtype,
							bancktype:this.bancktype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						this.statics.nazhinum = res.nazhistatics.totalCount?res.nazhistatics.totalCount:0
						this.statics.yqdznum = res.yqdzstatics.totalCount?res.yqdzstatics.totalCount:0

						
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			showErrorChange(e){
				this.foreingKey.showError = e?1:0
				this.customreload()
			},		
			list_beforeCreateGrid(gridOptions){
				return new Promise((reslove)=>{
					this.$api.invoice.listinvoicecompany().then((res) => {
						this.invoicecompany = res
						let customerId = this.list_formConfig.find((item)=>{
							return item.field == 'customerId'
						})
						if(customerId){
							customerId.itemRender.props.selectoptions = res.map((item)=>{
								return {
									value:item.customerId,
									label:item.customerName
								}
							})
						}
						gridOptions.pagerConfig = {
							enabled: false,
							autoHidden: false,
							border: true,
							size: 'mini',
							perfect: false,
							currentPage: 1,
							pageSize: 20,
							pageSizes: [10, 20, 50, 1000, 5000],
						}
						gridOptions.id = 'outputinvoice_list'
						gridOptions.height = 700
						gridOptions.pagerConfig.enabled = true
						gridOptions.editConfig.trigger = 'dblclick'
						
						gridOptions.columns = [			
							{type:'checkbox',title:'#',fixed:'left',width:50},
							{
								field:'invoiceNumber',
								title:'发票号码',
								render:'$input',
								props:{show:true},
								fixed:'left',
								width:150,
								slots: {
									default: ({row}) => {
										if(row.invoiceStatus == 3){
											return [
												<span style="color:#F56C6C" type = "text" size = "mini">{row.invoiceNumber}</span>,
											]
										}else {
											return [
												<span type = "text" size = "mini">{row.invoiceNumber}</span>,
											]
										}																			
									}
								}
							},
							{
								field:'customerId',
								title:'我方公司',
								render:'',
								formatter:({cellValue})=>{
									let target = this.invoicecompany.find((item)=>{
										return item.customerId == cellValue
									})
									if(target){
										return target.customerName
									}else{
										return cellValue
									}								
								},
								props:{show:true},
								width:100},
							{
								field:'invoiceClass',
								title:'发票种类',
								render:'$input',
								formatter:({cellValue})=>{
									if(cellValue == 31){
										return '数电票（专票）'
									}
									if(cellValue == 32){
										return '数电票（普票）'
									}									
								},
								props:{show:true},
								width:100,
							},
							{
								field:'bizDate',
								title:'开票日期',
								render:'$datePicker',
								formatter:({cellValue})=>{
									return window.systemMethods.timestampToDate(cellValue)
								},
								props:{show:true},
								width:100,
							},
							{
								field:'isrelation',
								title:'匹配任务',
								render:'',
								fixed:'right',
								slots: {
									default: ({row}) => {
										if(row.isrelation == 0){
											return [
												<span style="color:#F56C6C" type = "text" size = "mini">未执行</span>,
											]
										}
										if(row.isrelation == 1){
											return [
												<span style="color:#67C23A" type = "text" size = "mini">已执行</span>,
											]
										}																			
									}
								},
								props:{show:true},
								width:100,
							},
							{field:'taxItem',title:'征税项目',render:'',props:{show:true},width:100},
							{field:'buyerName',title:'购方名称',render:'',props:{show:true},width:100},
							{field:'cargoPrice',title:'不含税金额',render:'',props:{show:true},width:100},		
							{field:'taxRates',title:'税率',render:'',props:{show:true},width:100},	
							{field:'taxPrice',title:'税额',render:'',props:{show:true},width:100},	
							{field:'totalPrice',title:'价税合计',render:'',props:{show:true},width:100},	
							{field:'drawerName',title:'开票人',render:'',props:{show:true},width:100},		
							{
								field:'relationres',
								title:'关联商品',
								render:'',
								props:{show:true},
								width:100,
								fixed:'right',
								slots: {
									default: ({row}) => {
										if(row.relationres == 0){
											return [
												<span style="color:#F56C6C" type = "text" size = "mini">未关联</span>,
											]
										}
										if(row.relationres == 1){
											return [
												<span style="color:#67C23A" type = "text" size = "mini">已关联</span>,
											]
										}
										if(row.relationres == 2){
											return [
												<span style="color:#409EFF" type = "text" size = "mini">部分关联</span>,
											]
										}																				
									}
								}
							},
							{field:'relationsource',title:'关联来源',render:'',props:{show:true},width:100,fixed:'right'},
							{field:'headorderId',title:'线上订单号',render:'',props:{show:true},width:150,fixed:'right'},
							{field:'profit',title:'毛利率',render:'',props:{show:true},width:80,fixed:'right'},	
							{
								field:'customremark',
								title:'备注',
								editRender:{
									name:"$input",
									events:{
										blur:({row})=>{
											//alert(123)
											this.customremarkChange(row)
										}
									},
								},
								props:{show:true},
								width:80,
								fixed:'right',
							},	
							{
								field:'ignore',
								title:'忽略',
								render:'',
								cellRender:{
									name:'$switch',
									enabled:true,
									props:{
										openLabel:'是',
										closeLabel:'否',
										openValue:1,
										closeValue:0,
										size:'medium',
									},
									events:{
										change:({row})=>{
											this.ignoreChnage(row)
										}
									}
								},
								props:{show:true},
								width:100,
								fixed:'right',
							},														
							{
								title: '操作',
								fixed: "right",
								align: 'center',
								width: 65,
								slots: {
									default: ({row}) => {
										return [											
											<el-button style="color:#67C23A" type = "text" size = "mini" onClick = {() => {this.sourcefile(row)}}>原件</el-button>,
										]
									}
								}
							}
						]
						gridOptions.checkboxConfig = null
						
						gridOptions.toolbarConfig.buttons = [{
							name: '导出',
							status: 'success',
							code: 'export'
						},{
							name: '同步发票',
							status: 'primary',
							code: 'getyqdzinvoice'
						},{
							name: '生成亿企赢单据',
							status: 'primary',
							code: 'createyqdzorder'
						}]
						gridOptions.columns.forEach((item)=>{
							if(item.field=='serialNo'){
								item.slots = {
									default: ({row}) => {	
										let str= []
										if(row.cdSign==1){
											str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
										}
										if(row.cdSign==0){
											str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
										}
										str.push(<span>{row.serialNo}</span>)
										return str
									}
								}
							}
							if(item.field=='export_wln'){
								item.slots = {
									default:({row})=>{
										if(!row.export_wln){
											if(row.export_wln_error){
												return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
											}else{
												return <span style="color:#F56C6C;">未同步</span> 							
											}	
										}else{
											return <span>{row.export_wln}</span> 	
										}
									}
								}
							}
							if(item.field=='export_jindie'){
								item.slots = {
									default:({row})=>{
										if(row.export_jindie_sucess!=1){
											if(row.export_jindie_error){
												return <span style="color:#F56C6C;">{row.export_jindie_error}</span> 
											}else{
												return <span style="color:#F56C6C;">未同步</span> 							
											}	
										}else{
											return <span style="color:#67C23A;">已同步</span> 	
										}
									}
								}
							}
						})
						reslove()
					})
				})
			},
			customremarkChange(row){
				this.$api.invoice.updateoutputinvoice({
					invoiceNumber:row.invoiceNumber,
					customremark:row.customremark,
				}).then(()=>{
					this.$message.success('操作成功')
				})
	
			},
			showstream(row){
				this.streamdata = row.stream
				this.$refs.skstream.modal_show()
			},
			transferinventory(){
				
			},
			ignoreChnage(row){
				this.$api.invoice.setoutputinvoiceignore({
					id:row.id,
					ignore:row.ignore
				}).then(()=>{
					this.$message.success('操作成功')
				})
			},
			createyqdzorder(){
				this.$refs.outputinvoiceCreateyqdzorder.modal_show()
			},
			getyqdzinvoice(){
				
				let form = this.$refs.outputinvoicereport.getProxyInfo().form
				form = this.list_initupdateform(form)
				this.loading = true
				this.$api.invoice.getyqdzinvoice(form).then(() => {
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})			
			},
			sourcefile(row) {
				this.invoicedata = {
					invoiceNumber:row.invoiceNumber,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					orderId:row.orderId,
					orderPlant:row.orderPlant,
					invoiceType:1
				}
				this.tab = ['invoice','detail']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('haspaper') !== -1) {
					if (row.haspaper == 6) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.haspaper == 5) {
						return {
							color: '#67C23A'
						}
					}
				}
			},
			paymentsummary() {
				let form = this.$refs.outputinvoicereport.getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},
			custommark(row){
				this.$prompt('请输入内容【'+row.serialNo+'】','提示').then(({ value })=>{
					this.$api.reconciliation_bankflow.custommark({
						fundtype:this.fundtype,
						bancktype:this.bancktype,
						custommark:value,
						id:row.id
					}).then(() => {
						row.custommark = value
					})
				})
			},
			edit(row){
				// if(row.relationtype == 1){
				// 	this.$message.error('自动关联的流水无法编辑')
				// 	return
				// }
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			customreload(){
				this.$refs.outputinvoicereport.commitProxy('query')
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs.outputinvoicereport.getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			invoiceConfig,
			createyqdzorder
		}
	}
</script>